import { atom, useAtom } from "jotai";

import { type RFQRequestState } from "#/services/kyan/kyan.types";
import { isEqualAddress } from "#/utils/isEqualAddress";

import { usePositionsDrawerMarket } from "../app/positionsDrawer/positionsDrawerMarket";
import { useAccount } from "../wallet/account/account";
import { useRfqResponses } from "./rfqResponses";

const rfqRequestsAtom = atom<RFQRequestState[]>([]);

export const useRfqRequests = () => {
  const { marketResponses } = useRfqResponses();
  const { market } = usePositionsDrawerMarket();
  const { account } = useAccount();

  const [rfqRequests, setRfqRequests] = useAtom(rfqRequestsAtom);

  const marketRequests = rfqRequests.filter((request) =>
    request.marketPairs.includes(market.pair),
  );

  const userRfqRequests = rfqRequests.filter((request) =>
    isEqualAddress(request.taker, account),
  );
  const userMarketRequests = userRfqRequests.filter((request) =>
    request.marketPairs.includes(market.pair),
  );

  const requestsAwaitingResponses = userMarketRequests.filter((request) => {
    return !marketResponses.some(
      (response) => response.orderId === request.orderId,
    );
  });

  return {
    userRfqRequests,
    userMarketRequests,
    rfqRequests,
    marketRequests,
    requestsAwaitingResponses,
    setRfqRequests,
  };
};
